import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as styles from './Composebox.scss';
var AdBoostArea = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(AdBoostArea, _Component);

  var _super = _createSuper(AdBoostArea);

  function AdBoostArea() {
    var _this;

    _classCallCheck(this, AdBoostArea);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "formatCurrency", function (amount) {
      var cents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var amountInDollars = cents ? amount / 100.0 : amount;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(amountInDollars);
    });

    return _this;
  }

  _createClass(AdBoostArea, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var composeboxForm = this.props.composeboxForm;
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          paddingTop: 10
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, "Ad Name: "), /*#__PURE__*/React.createElement("span", null, composeboxForm.fromPlannedAd.name, " "))), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          paddingTop: 10
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          fontWeight: 400
        }
      }, "Boost Amount: "), /*#__PURE__*/React.createElement("span", null, this.formatCurrency(composeboxForm.fromPlannedAd.budget), " "))));
    }
  }]);

  return AdBoostArea;
}(Component)) || _class);
export { AdBoostArea as default };